import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { loadDocumentByIdFailed, loadDocumentByIdSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* loadDocumentById(action) {
  try {
    const url = `${BACKEND_URL}/proxy/backend/api/v1/resources/documents/${action.payload}`;
    const dataResponse = yield makeRequest(url, {}, action, 'GET', true);
    if (dataResponse.status === OK) {
      const data = yield dataResponse.json();
      yield put(loadDocumentByIdSuccessful(data.data));
      yield call(resolveActionPromise(action, data.data));
    } else {
      yield put(loadDocumentByIdFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(loadDocumentByIdFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
